import { makeVar } from '@apollo/client'
import { ClaimBalanceSwitchTypes } from '../types'

export const activeBalanceClaimSwitchTypeVar = makeVar<ClaimBalanceSwitchTypes>(
  ClaimBalanceSwitchTypes.Deposit
)
